export const theme = {
  colors: {
    background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
    backgroundSolid: '#1e3c72',
    sidebar: 'rgba(15, 30, 60, 0.92)',
    header: 'rgba(15, 30, 60, 0.85)',
    card: 'rgba(255, 255, 255, 0.1)',
    cardHover: 'rgba(255, 255, 255, 0.15)',
    cardSubtle: 'rgba(255, 255, 255, 0.05)',
    modalBackground: 'rgba(20, 40, 80, 0.98)',
    overlay: 'rgba(0, 0, 0, 0.6)',
    primary: '#667eea',
    primaryHover: '#5a6fd6',
    primaryGradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    primaryGradientHover: 'linear-gradient(135deg, #5a6fd6 0%, #6a4190 100%)',
    success: '#22C55E',
    warning: '#F59E0B',
    danger: '#EF4444',
    text: {
      primary: '#FFFFFF',
      secondary: 'rgba(255, 255, 255, 0.8)',
      muted: 'rgba(255, 255, 255, 0.6)'
    },
    border: 'rgba(255, 255, 255, 0.2)',
    borderLight: 'rgba(255, 255, 255, 0.1)',
    inputBackground: 'rgba(255, 255, 255, 0.1)',
    inputBorder: 'rgba(255, 255, 255, 0.3)',
    navActive: 'rgba(102, 126, 234, 0.25)',
    navHover: 'rgba(255, 255, 255, 0.08)',
    scrollbarTrack: 'rgba(255, 255, 255, 0.05)',
    scrollbarThumb: 'rgba(255, 255, 255, 0.2)',
    scrollbarThumbHover: 'rgba(255, 255, 255, 0.35)'
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    '2xl': '48px',
    '3xl': '64px'
  },
  borderRadius: {
    sm: '4px',
    md: '8px',
    lg: '12px',
    xl: '16px',
    full: '9999px'
  },
  shadows: {
    sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    md: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
    lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
    xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1)'
  },
  fontWeights: {
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700
  },
  fontSizes: {
    xs: '12px',
    sm: '14px',
    base: '16px',
    lg: '18px',
    xl: '20px',
    '2xl': '24px',
    '3xl': '30px',
    '4xl': '36px'
  }
};

export default theme;
